//make jQuery accessible globally.
window.jQuery = require('jquery');
window.$ = jQuery;

window.Popper = require('popper.js');
Popper.default.Defaults.modifiers.computeStyle.gpuAcceleration = false;
if (typeof bootstrap === 'undefined') {
    require('bootstrap');
    window.__bootstrapLoaded = true;
}

const debounce = require('lodash/debounce');
const waypoints = require('./waypoints.js');
const { isInsideElement } = require('../lib/utils/dom-utils.js');
const { scrollToTop } = require('../lib/utils/scroll-utils.js');

import { loadScripts, loadScrollDelayedScripts, loadHeaderSearch } from './index-module.js';

window.addEventListener("DOMContentLoaded", () => {
    const carouselSelectors = [
        ".fund-carousel-block__main--desktop",
        "ve-fundcarouselusblock",
        ".slider-for",
        ".recommended-insights__list",
        ".carousel-block__main--desktop",
        ".carousel-wrapper__main--desktop",
        ".more-from-category__main--desktop",
        ".latest-digital-grid__main--desktop",
        ".bau-carousel-hero"
        ];
    let carouselBool = carouselSelectors.some(selector => document.querySelector(selector));

    (async () => {
        await loadScripts(carouselBool);
    })();

    //Scroll listener to only load delayed scripts below the fold
    const loadScriptsScrollListener = debounce(() => {
        const heightOffset = window.innerHeight / 4;
        const ScrolledTop = window.pageYOffset || document.documentElement.scrollTop
        if (ScrolledTop > heightOffset) {
            (async () => {
                await loadScrollDelayedScripts(carouselBool);
            })();
            return window.removeEventListener("scroll", loadScriptsScrollListener);
        }
    }, 100);
    window.addEventListener("scroll", loadScriptsScrollListener);
    loadScriptsScrollListener(); //trigger it once anyway, incase the page is already scrolled down.

    // load Search
    const searchIcons = document.querySelectorAll("header button.site-header__nav-link[data-target='#site-header-search']");
    if (searchIcons.length > 0) {
        searchIcons.forEach((searchIcon) => {
            searchIcon.addEventListener("click", () => {
                (async () => {
                    /* Adds a class to the dynamic modal backdrop so we can style it as needed. */
                    var SearchBackdropClass = "bs4-search-backdrop";
                    var stickyWrap = $('.sticky-wrap');
                    $("#site-header-search").on('shown.bs.modal', function () {
                        $('.modal-backdrop').addClass(SearchBackdropClass);
                        $(".bs4-nav .alert-bar").addClass('alertbar-overlay');
                        if (stickyWrap.length) {
                            stickyWrap.addClass('hidden');
                        }
                    }).on('hidden.bs.modal', function () {
                        $('.modal-backdrop').addClass(SearchBackdropClass);
                        $(".bs4-nav .alert-bar").removeClass('alertbar-overlay');
                        // clear input field when modal is closed
                        $('.search__container #autocomplete').val('');
                        if (stickyWrap.length) {
                            stickyWrap.removeClass('hidden');
                        }
                    });
                    await loadHeaderSearch();
                })();
            }, { once: true });
        });
    }
});

/* eslint-disable no-undef */
$(function() {
  
  $('.recommended-insights .tab-nav__link').on('shown.bs.tab', function() {
    const id = $(this).index('.recommended-insights .tab-nav__link');
    $('.tab-nav__list li').each(function(index) {
      $(`.recommended-insights__actions-${index}`).css('display', 'none');
    });
    $(`.recommended-insights__actions-${id}`).css('display', 'block');
  });

function menuEventListeners() {
  /* eslint-enable max-len */
  // SiteHeader
  $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu', (event) => {
    if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
      event.stopPropagation();
    }
  });

  $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu-toggle', () => {
    scrollToTop();
  });

  $(document).on('click.bs.dropdown.data-api', '.site-header__submenu .list-group-item-action', (event) => {
    event.stopPropagation();
  });

  $(document).on('click.bs.dropdown.data-api', '.site-header__submenu', (event) => {
    if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
      event.stopPropagation();
    }
  });

  $('.site-header__submenu-action').on('mouseenter', (event) => {
    const actionElement = $(event.target),
          menuId = actionElement.attr('data-menu'),
          descriptionId = actionElement.attr('data-description'),
          currentActiveAction = $('#' + menuId + ' .list-group .list-group-item.active'),
          currentActivePane = $('#' + menuId + ' .site-header__submenu-content .tab-pane.active'),
          targetPane = $('#' + menuId + ' .site-header__submenu-content .tab-pane#' + descriptionId);

    $('#' + menuId + ' .site-header__submenu-content').attr('data-pane', currentActiveAction.attr('data-default'));
    currentActivePane.removeClass('show active');
    targetPane.tab("show");
    actionElement.tab("show");
    currentActiveAction.removeClass('active');
  });

  $('.site-header .navbar-toggler').on('click', (event) => {
    const header = $('#sticky-site-header');
    const toggleElement = $(event.target),
          targetId = toggleElement.attr('data-target'),
          targetElement = $(targetId);

    header.toggleClass('open-menu');
    toggleElement.toggleClass('collapsed');
    targetElement.toggleClass('show');
  });

  $('.site-header__mobile-submenu-toggle').on('click', (event) => {
    const toggleElement = $(event.target),
          targetId = toggleElement.attr('data-target'),
          targetElement = $(targetId);

    targetElement.toggleClass('show');
  });


  $('.site-header__mobile-sub-submenu-toggle').on('click', (event) => {
    const toggleElement = $(event.target),
          targetId = toggleElement.attr('data-target'),
          targetElement = $(targetId);

    targetElement.toggleClass('show');
  });

}

document.addEventListener('dynamicMenuLoaded', menuEventListeners);
  waypoints.init();
  waypoints.sectionHeaderInit();
  waypoints.tableHeaderInit();
});

/* scroll to top */
$(window).scroll(function() {
  if ($(window).scrollTop() >= $('main').offset().top + $('main').outerHeight() - window.innerHeight) {
    // footer part
    $('.scroll-to-top').css({ 'animation': 'fadeIn 0s', 'visibility': 'visible' });
    $('.scroll-to-top').addClass('table-sticky').removeClass('sticky-fixed');
  }
  else if ($(this).scrollTop() < 100) {
    $('.scroll-to-top').css({ 'animation': 'fadeIn 0s', 'visibility': 'hidden' });
  }
  else {
    // upper part
    $('.scroll-to-top').css({ 'animation': 'fadeOut 0s', 'visibility': 'visible' });
    $('.scroll-to-top').addClass('sticky-fixed').removeClass('table-sticky');
  }
});

$('.scroll-to-top').on('click', function() {
  $('.scroll-to-top').css({ 'animation': 'fadeIn 0s', 'visibility': 'hidden' });
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

/* sticky nav shadow */
$('.site-header__nav-item').hover(function() {
  $('.site-header.sticky').css('z-index', 1060);
}, function() {
  $('.site-header.sticky').css('z-index', 1020);
});

// Print page
$('.share-widget .print').on('click', function () {
    $('#share-modal').modal('hide')
    $('.share-widget').removeClass('show');
    $('.share-widget__menu').removeClass('show');
    window.print();
});

// Trap focus inside modal and menus
const focusableEl = 'button, a, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

$('.focusable-menu').each(function () {
    const selectFocusElement = $(this);

    const firstFocusableEl = selectFocusElement[0].querySelectorAll(focusableEl)[0];
    const focusableCn = selectFocusElement[0].querySelectorAll(focusableEl);
    const lastFocusableEl = focusableCn[focusableCn.length - 1];

    document.addEventListener('keydown', function (e) {
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
    if (firstFocusableEl != undefined && typeof firstFocusableEl.focus == "function") {
        firstFocusableEl.focus();
    }

});

// Alert bar
$('.alert-bar__ctalink').on('click', function () {
    $('.alert-bar__content').hide();
});

// Follow and Share Widget menu position
function followAndShareWidgetPosition() {
    const widgetDropdownEL = $('.widget.dropdown');

    if (widgetDropdownEL) {
        widgetDropdownEL.each(function (i) {
            if (widgetDropdownEL[i].classList.contains("ignore-placement-fix")) {
                return;
            }

            const widgetEl = $(this);

            const widgetOffsetLeft = widgetEl.offset().left;
            const widgetOffsetRight = $('body').innerWidth() - widgetEl.width() - widgetEl.offset().left;
            const widgetMenuWidth = 300;
            const offset = 5;
            const widgetCaretPosition = widgetMenuWidth / 2 - offset;

            const widgetMenuEl = widgetEl.find('.widget-menu');

            if (widgetOffsetLeft > widgetCaretPosition && widgetOffsetRight > widgetCaretPosition) {
                widgetMenuEl.removeClass('widget-menu-left widget-menu-center widget-menu-right');
                widgetMenuEl.addClass('widget-menu-center');
            }
            else if (
                widgetOffsetLeft > widgetCaretPosition &&
                widgetOffsetRight < widgetCaretPosition
            ) {
                widgetMenuEl.removeClass('widget-menu-left widget-menu-center widget-menu-right');
                widgetMenuEl.addClass('widget-menu-left');
            }
            else if (
                widgetOffsetLeft < widgetCaretPosition &&
                widgetOffsetRight > widgetCaretPosition
            ) {
                widgetMenuEl.removeClass('widget-menu-left widget-menu-center widget-menu-right');
                widgetMenuEl.addClass('widget-menu-right');
            }
        });
    }
}

followAndShareWidgetPosition();
$(window).on('resize', debounce(followAndShareWidgetPosition, 250));

function AttachmentBlock() {
    // Attachment Block
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const shimmer = entry.target.querySelector('.attachment-block__content-bg-shimmer');

            if (entry.isIntersecting && shimmer) {
                shimmer.classList.add('gleam-animation');
                return;
            }
        });
    });

    document.querySelectorAll('.attachment-block').forEach((i) => {
        if (i) {
            observer.observe(i);
        }
    });

}

if (typeof IntersectionObserver != "function") {
    /* Microsoft Internet Explorer detected in. || intersection observer not present */
    //First get the IO Polyfill
    $.getScript("https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver").done(() => {
        //then run yall.
        AttachmentBlock();
    });
} else {
    AttachmentBlock();
}

// Utility menu and Register form - country and state logic
$(function () {
    $('.form-country-container').each(function () {
        const countryField = $(this);
        countryField.find('.dropdown-menu .dropdown-item').on('click', function () {
            const dropdownMenuItemLabel = $(this).text();

            // Update selected option
            countryField.find('#country-dropdown .dropdown__label').text(dropdownMenuItemLabel);
            countryField
                .find('.dropdown__button')
                .find('option')
                .each(function () {
                    const option = $(this);
                    if (option.text() === dropdownMenuItemLabel) {
                        option.attr('selected', 'selected');
                    }
                    else {
                        option.removeAttr('selected');
                    }
                });

            // Disable state field if the country is not 'United States'
            const stateDropdown = countryField.next().find('#state-dropdown');
            if (dropdownMenuItemLabel !== 'United States') {
                stateDropdown.attr({
                    disabled: true,
                    'aria-disabled': true,
                });
            }
            else {
                stateDropdown.attr({
                    'disabled': false,
                    'aria-disabled': false,
                });
            }
        });
    });
});


$('#site-header-search').on('shown.bs.modal', function () {
    $('.modal-backdrop').appendTo('.root');
});

$('#gateway-modal').on('shown.bs.modal', function () {
    $('.modal-backdrop').css('z-index', 980);
});
// alertbar button hover
$('.alert-bar__ctalink').hover(function () {
    $('.alert-bar__left-label').toggleClass('text-decoration-none');
});

// header height
$('.alert-bar__ctalink').on('click', function () {
    $('.sticky-wrapper').css('height', '95');
});
